import { useEffect, useEffectEvent, useRef } from 'react'

/** 任务状态同步到缓存；重渲染和重复终态响应不会重复触发完成处理。 */
export function useBatchJobCompletion({
  jobId,
  state,
  onComplete,
  onError
}: {
  jobId?: string
  state?: string
  onComplete: () => Promise<void>
  onError: () => void
}) {
  const handled = useRef(new Set<string>())
  const complete = useEffectEvent(() => {
    void onComplete().catch(onError)
  })
  useEffect(() => {
    if (!jobId || !['completed', 'failed', 'missing'].includes(state ?? '') || handled.current.has(jobId)) return
    handled.current.add(jobId)
    complete()
  }, [jobId, state])
}
